import { defineStore, storeToRefs } from 'pinia';
import { usePerformerStore, type Slice } from './performer';
import { match } from '@/api/performer/utils';
import { useUserStore } from './user';
import { useCamStore } from './cam';

export const useSidebarStore = defineStore({
    id: 'sidebar',
    state: () => ({
        activeTab: 'none',
        collapse: false,
        filters: { offset: 0, limit: 100 },
        bodyWidth: undefined,
        search: ''
    }),
    actions: {
        switchTab(name: string) {
            if (name === this.activeTab) {
                return;
            }
            this.loadData(name);

            this.activeTab = name;
        },
        loadData(name: string) {
            switch (name) {
                case 'favorites': {
                    usePerformerStore().loadFavorites(this.filters);
                    break;
                }
                case 'peek': {
                    usePerformerStore().loadPeekers(this.filters);
                    break;
                }
                case 'voyeur': {
                    usePerformerStore().loadTeasers(this.filters);
                    break;
                }
                default:
                    throw `${name} is not a known slice. We know: favorites, peekers, teasers`;
            }
        },
        switchState() {
            this.collapse = !this.collapse;
        },
        setBodyWidth(nr: Number | any) {
            this.bodyWidth = nr;
        }
    },
    getters: {
        currentSlice(): Slice {
            if (this.activeTab === 'none') {
                return {
                    name: 'none',
                    filter: { offset: 0, limit: -1 },
                    status: 'new',
                    items: [],
                    fetchedAt: Date.now()
                };
            } else {
                const slice = { ...usePerformerStore().getSlice(this.activeTab) };
                slice.items = slice.items.filter(id => match(usePerformerStore().getById(id), this.search));
                return slice;
            }
        }
    }
});
